<!-- FrontPage/src/screens/LoginScreen.vue -->
<template>
  <div class="login-page">
    <!-- 背景动效层 -->
    <div class="login-bg">
      <div class="login-bg-aurora"></div>
      <div class="login-bg-particles"></div>
      <div class="login-bg-scan"></div>
      <div class="bg-orbit bg-orbit-1"></div>
      <div class="bg-orbit bg-orbit-2"></div>
      <div class="bg-orbit bg-orbit-3"></div>
    </div>

    <!-- 顶部品牌栏 -->
    <header class="login-header">
      <div class="login-header-left">
        <div class="login-logo-circle">YJ</div>
        <div class="login-header-text">
          <div class="login-system-name">合同管理系统</div>
          <div class="login-system-subtitle">Contract Management Platform</div>
        </div>
      </div>
    </header>

    <!-- 中间内容区：左侧品牌介绍 + 右侧登录框 -->
    <main class="login-main">
      <section class="login-hero" v-if="!isMobile">
        <div class="login-hero-title">让合同管理，更智能</div>
        <div class="login-hero-subtitle">
          集中管理 · 智能审批 · 全流程可追溯。<br />
          为项目合作提供高效、安全的合同管理能力。
        </div>
        <div class="login-hero-tags">
          <span class="tag-pill">Intelligent OCR</span>
          <span class="tag-pill">Progress Tracking</span>
          <span class="tag-pill">Analytics</span>
        </div>
        <!-- 左侧科技感动态信息（只展示 OCR / 可视化 / 权限 等能力） -->
        <div class="login-hero-metrics">
          <div class="metric-item">
            <div class="metric-dot"></div>
            <div class="metric-content">
              <div class="metric-title">智能 OCR 引擎</div>
              <div class="metric-value">合同影像文字识别</div>
            </div>
          </div>
          <div class="metric-item">
            <div class="metric-dot metric-dot-teal"></div>
            <div class="metric-content">
              <div class="metric-title">合同数据可视化</div>
              <div class="metric-value">进度一图呈现</div>
            </div>
          </div>
          <div class="metric-item">
            <div class="metric-dot metric-dot-pink"></div>
            <div class="metric-content">
              <div class="metric-title">多角色协同与权限</div>
              <div class="metric-value">分级权限控制</div>
            </div>
          </div>
        </div>
      </section>

      <section class="login-card-wrapper">
        <transition name="card-zoom" appear>
          <div class="login-card">
            <div class="login-card-header">
              <h3 class="login-title">欢迎登录</h3>
              <p class="login-subtitle">请使用统一账号登录合同管理系统</p>
            </div>

            <el-form
              ref="loginForm"
              :model="loginForm"
              :rules="rules"
              status-icon
              :label-width="label_date.width"
              class="login-form"
            >
              <el-form-item :label="label_date.user" prop="username">
                <el-input
                  v-model.number="loginForm.username"
                  placeholder="请输入账号"
                  class="modern-input"
                  prefix-icon="el-icon-user"
                />
              </el-form-item>

              <el-form-item :label="label_date.pwd" prop="password">
                <el-input
                  :type="passwordType"
                  v-model="loginForm.password"
                  autocomplete="off"
                  placeholder="请输入密码"
                  class="modern-input"
                  prefix-icon="el-icon-lock"
                  ref="password"
                >
                  <i
                    slot="suffix"
                    :class="['password-toggle', passwordType === 'password' ? 'el-icon-view' : 'el-icon-view-off']"
                    @click="showPwd"
                  ></i>
                </el-input>
              </el-form-item>

              <el-form-item :label="label_date.cap" prop="captcha">
                <div class="captcha-input-container">
                  <el-input
                    v-model="loginForm.captcha"
                    placeholder="请输入验证码"
                    autocomplete="off"
                    class="modern-input"
                    @keyup.enter.native="submitForm('loginForm')"
                    prefix-icon="el-icon-key"
                  />
                  <img
                    class="captcha-img"
                    src=""
                    ref="code"
                    alt="verify"
                    @click="changeCode"
                  />
                </div>
              </el-form-item>

              <el-form-item label-width="0px" class="login-btn-row">
                <el-button
                  icon="el-icon-s-custom"
                  type="primary"
                  class="modern-button login-submit-button"
                  :loading="loginSubmitting"
                  :disabled="loginSubmitting"
                  @click="submitForm('loginForm')"
                >
                  登陆系统
                </el-button>
              </el-form-item>
            </el-form>

            <div class="login-footer-tip">
              忘记密码请联系系统管理员重置
            </div>
          </div>
        </transition>
      </section>
    </main>
  </div>
</template>

<script>
import "element-ui/lib/theme-chalk/display.css";
import { login, getCaptcha } from "../api/index";

export default {
  name: "LoginScreen",
  data() {
    // 自定义前端验证规则
    const validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    const validateUser = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入账号"));
      } else {
        callback();
      }
    };
    const validateCap = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入验证码"));
      } else {
        callback();
      }
    };

    return {
      label_date: {
        width: "70px",
        user: "账号",
        pwd: "密码",
        cap: "验证码",
      },
      // 表单数据
      loginForm: {
        password: "",
        username: "",
        captcha: "",
      },
      // 校验规则
      rules: {
        password: [{ validator: validatePass, trigger: "blur" }],
        username: [{ validator: validateUser, trigger: "blur" }],
        captcha: [{ validator: validateCap, trigger: "blur" }],
      },
      passwordType: "password",
      isMobile: document.documentElement.clientWidth < 720,
      loginSubmitting: false,
    };
  },
  mounted() {
    // 得到验证码图片
    this.changeCode();

    if (document.documentElement.clientWidth < 390) {
      this.label_date = {
        width: "0px",
        user: "",
        pwd: "",
        cap: "",
      };
    }

    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.isMobile = document.documentElement.clientWidth < 720;
    },
    // 点击登陆，提交表单（防重复提交：狂按回车不会多发请求）
    submitForm(formName) {
      if (this.loginSubmitting) return;
      let _this = this;
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        _this.loginSubmitting = true;
        let params = new URLSearchParams();
        params.append("username", this.loginForm.username);
        params.append("password", this.loginForm.password);
        params.append("captcha", this.loginForm.captcha);
        login(params)
          .then((res) => {
            if (res.code === 0) {
              _this.$notify({ title: "登录成功", type: "success", duration: 1200 });
              setTimeout(function () {
                _this.$router.push({ path: "/yj/home" });
              }, 500);
            } else {
              _this.loginSubmitting = false;
              _this.$message({ message: res.msg, type: "error" });
              _this.changeCode();
            }
          })
          .catch(() => {
            _this.loginSubmitting = false;
          });
      });
    },
    // 获取随机数作来生成验证码
    getCaptchaKey() {
      return Math.random();
    },
    // 刷新验证码
    changeCode() {
      let _this = this;
      let captcha_key = this.getCaptchaKey();
      getCaptcha(captcha_key)
        .then((res) => {
          _this.$refs.code.setAttribute(
            "src",
            window.URL.createObjectURL(res)
          );
        })
        .catch(() => {});
    },
    showPwd() {
      this.passwordType = this.passwordType === "password" ? "" : "password";
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
  },
};
</script>

<style scoped>
/* 整体布局 */
.login-page {
  position: relative;
  min-height: 100vh;
  width: 100%;
  overflow: hidden;
  color: #e5e9f0;
  /* 比原来略微提亮的深色渐变背景 */
  background: radial-gradient(circle at top left, #243b8a 0%, #0b2f6a 40%, #020617 100%);
}

/* 背景底图 + 模糊 */
.login-bg::before {
  content: "";
  position: fixed;
  inset: 0;
  /* 使用纯 CSS 渐变和光效作为背景，而不是图片 */
  background:
    radial-gradient(circle at 10% 0%, rgba(56, 189, 248, 0.23), transparent 55%),
    radial-gradient(circle at 90% 100%, rgba(129, 140, 248, 0.22), transparent 55%),
    linear-gradient(145deg, rgba(15, 23, 42, 0.95), rgba(15, 23, 42, 0.98));
  filter: blur(6px);
  transform: scale(1.03);
  z-index: -2;
}

/* 科技感网格与扫描光带 */
.login-bg {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}

/* 柔和极光带效果 */
.login-bg-aurora {
  position: absolute;
  inset: -10% -30%;
  background:
    radial-gradient(circle at 10% 20%, rgba(56, 189, 248, 0.16), transparent 55%),
    radial-gradient(circle at 80% 40%, rgba(129, 140, 248, 0.18), transparent 60%),
    linear-gradient(
      120deg,
      transparent 0,
      rgba(56, 189, 248, 0.2) 25%,
      rgba(94, 234, 212, 0.32) 40%,
      transparent 60%,
      transparent 100%
    ),
    linear-gradient(
      -120deg,
      transparent 0,
      rgba(129, 140, 248, 0.18) 35%,
      rgba(244, 114, 182, 0.26) 55%,
      transparent 75%,
      transparent 100%
    );
  filter: blur(18px);
  opacity: 0.55;
  mix-blend-mode: screen;
  animation: aurora-move 22s ease-in-out infinite alternate;
}

/* 全新：柔和光雾粒子层（大面积模糊，不再是小点/小块） */
.login-bg-particles {
  position: absolute;
  inset: -15% -20%;
  /* 多层大圆形散景光斑，提升存在感但保持圆润 */
  background:
    radial-gradient(circle at 18% 28%, rgba(125, 211, 252, 0.45) 0, transparent 62%),
    radial-gradient(circle at 78% 24%, rgba(129, 140, 248, 0.4) 0, transparent 60%),
    radial-gradient(circle at 26% 80%, rgba(45, 212, 191, 0.38) 0, transparent 60%),
    radial-gradient(circle at 84% 78%, rgba(244, 114, 182, 0.42) 0, transparent 60%),
    radial-gradient(circle at 50% 50%, rgba(15, 23, 42, 0.75) 0, transparent 80%);
  filter: blur(18px);
  opacity: 0.68;
  mix-blend-mode: screen;
  pointer-events: none;
  animation: particle-twinkle 26s ease-in-out infinite alternate;
}

.login-bg-scan {
  position: absolute;
  width: 220px;
  height: 120%;
  left: 12%;
  top: -10%;
  background: radial-gradient(circle at 10% 0%, rgba(56, 189, 248, 0.45), transparent 60%);
  filter: blur(4px);
  opacity: 0;
  animation: scan-move 7s ease-in-out infinite;
  mix-blend-mode: screen;
}

/* 背景轨道动效 */
.bg-orbit {
  position: fixed;
  border-radius: 50%;
  border: 1px solid rgba(64, 158, 255, 0.2);
  box-shadow: 0 0 40px rgba(64, 158, 255, 0.25);
  animation: orbit 18s linear infinite;
  z-index: -1;
}

.bg-orbit-1 {
  width: 480px;
  height: 480px;
  top: -120px;
  right: -120px;
  border-color: rgba(64, 158, 255, 0.35);
}

.bg-orbit-2 {
  width: 360px;
  height: 360px;
  bottom: -80px;
  left: -40px;
  animation-duration: 22s;
  border-color: rgba(45, 212, 191, 0.25);
}

.bg-orbit-3 {
  width: 260px;
  height: 260px;
  top: 40%;
  left: 55%;
  animation-duration: 26s;
  border-color: rgba(236, 72, 153, 0.28);
}

/* 顶部品牌栏 */
.login-header {
  position: relative;
  z-index: 1;
  height: 64px;
  padding: 0 40px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background: linear-gradient(
    135deg,
    rgba(12, 30, 72, 0.9),
    rgba(24, 119, 195, 0.85)
  );
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.35);
  border-bottom: 1px solid rgba(148, 163, 184, 0.35);
}

.login-header-left {
  display: flex;
  align-items: center;
}

.login-logo-circle {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: radial-gradient(circle at 30% 20%, #60a5fa, #1d4ed8);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #e5e7eb;
  font-weight: 700;
  letter-spacing: 0.1em;
  margin-right: 12px;
  box-shadow: 0 0 18px rgba(59, 130, 246, 0.8);
}

.login-header-text {
  display: flex;
  flex-direction: column;
}

.login-system-name {
  font-size: 18px;
  font-weight: 600;
  color: #f9fafb;
}

.login-system-subtitle {
  font-size: 12px;
  color: rgba(226, 232, 240, 0.85);
}

/* 主体内容区 */
.login-main {
  position: relative;
  z-index: 1;
  min-height: calc(100vh - 64px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 40px 40px;
  gap: 48px;
}

/* 左侧展示文案 */
.login-hero {
  max-width: 480px;
  color: #e5e7eb;
  animation: fadeInUp 0.9s ease both;
}

.login-hero-title {
  font-size: 30px;
  font-weight: 700;
  margin-bottom: 12px;
  position: relative;
}

.login-hero-subtitle {
  font-size: 14px;
  line-height: 1.8;
  color: #cbd5f5;
  margin-bottom: 18px;
}

.login-hero-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag-pill {
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 12px;
  background: linear-gradient(135deg, rgba(15, 23, 42, 0.9), rgba(15, 23, 42, 0.7));
  border: 1px solid rgba(94, 234, 212, 0.6);
  color: #e5e7eb;
  position: relative;
  overflow: hidden;
  box-shadow: 0 0 10px rgba(45, 212, 191, 0.4);
}

.tag-pill::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(120deg, transparent 0%, rgba(94, 234, 212, 0.35) 40%, transparent 80%);
  transform: translateX(-120%);
  opacity: 0;
}

.tag-pill:hover::after {
  animation: tag-shine 1.4s ease-out forwards;
}

/* 左侧科技感动态信息 */
.login-hero-metrics {
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid rgba(148, 163, 184, 0.28);
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
}

.metric-item {
  display: flex;
  align-items: center;
  padding: 6px 8px;
  border-radius: 12px;
  background: radial-gradient(circle at top, rgba(15, 23, 42, 0.9), rgba(15, 23, 42, 0.75));
  box-shadow: 0 0 16px rgba(15, 23, 42, 0.6);
  border: 1px solid rgba(59, 130, 246, 0.4);
  position: relative;
  overflow: hidden;
}

.metric-item::after {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at 120% -20%, rgba(56, 189, 248, 0.22), transparent 55%);
  opacity: 0.9;
  mix-blend-mode: screen;
  pointer-events: none;
}


.metric-dot {
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #60a5fa;
  box-shadow: 0 0 12px rgba(96, 165, 250, 0.95);
  margin-right: 8px;
  animation: pulse 1.8s ease-in-out infinite;
}

.metric-dot-teal {
  background: #22d3ee;
  box-shadow: 0 0 12px rgba(45, 212, 191, 0.95);
  animation-delay: 0.3s;
}

.metric-dot-pink {
  background: #f472b6;
  box-shadow: 0 0 12px rgba(244, 114, 182, 0.95);
  animation-delay: 0.6s;
}

.metric-content {
  position: relative;
  z-index: 1;
}

.metric-title {
  font-size: 11px;
  color: rgba(226, 232, 240, 0.9);
  margin-bottom: 2px;
}

.metric-value {
  font-size: 14px;
  font-weight: 600;
  color: #f9fafb;
}

.metric-unit {
  font-size: 11px;
  opacity: 0.85;
}

/* 登录卡片 */
.login-card-wrapper {
  max-width: 420px;
  width: 100%;
}

.login-card {
  /* 卡片整体略微提亮，保持玻璃质感 */
  background:
    radial-gradient(circle at 0 0, rgba(59, 130, 246, 0.2), transparent 55%),
    radial-gradient(circle at 100% 0, rgba(236, 72, 153, 0.16), transparent 60%),
    radial-gradient(circle at 50% 120%, rgba(56, 189, 248, 0.13), transparent 60%),
    linear-gradient(145deg, rgba(15, 30, 70, 0.96), rgba(15, 23, 42, 0.96));
  border-radius: 28px;
  padding: 28px 32px 26px;
  position: relative;
  box-shadow:
    0 18px 40px rgba(15, 23, 42, 0.7),
    0 0 0 1px rgba(148, 163, 184, 0.35);
  backdrop-filter: blur(20px);
  transform-style: preserve-3d;
  overflow: hidden;
}

.login-card::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 1px;
  background: linear-gradient(
    135deg,
    rgba(56, 189, 248, 0.45),
    rgba(37, 99, 235, 0.65),
    rgba(244, 114, 182, 0.4)
  );
  -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  opacity: 0.8;
}

.login-card::after {
  /* 卡片内轻微扫描高光 */
  content: "";
  position: absolute;
  inset: -40%;
  background: radial-gradient(circle at 0 0, rgba(248, 250, 252, 0.18), transparent 55%);
  opacity: 0;
  mix-blend-mode: screen;
  animation: card-glow 14s ease-in-out infinite;
  pointer-events: none;
}

/* 标题 */
.login-card-header {
  text-align: center;
  margin-bottom: 24px;
}

.login-title {
  margin: 0 0 6px;
  color: #f9fafb;
  letter-spacing: 0.16em;
  font-weight: 500;
  font-size: 1.3em;
}

.login-subtitle {
  margin: 0;
  font-size: 13px;
  color: #9ca3af;
}

/* 表单 */
.login-form {
  margin-top: 8px;
}

.login-form >>> .el-form-item__label {
  text-align-last: justify;
  width: 100%;
  color: #e5e7eb;
}

/* 输入框 */
.modern-input >>> .el-input__inner {
  background-color: rgba(15, 30, 70, 0.9);
  border-radius: 10px;
  border: 1px solid rgba(148, 163, 184, 0.6);
  color: #e5e7eb;
  transition: all 0.25s ease;
}

.modern-input:hover >>> .el-input__inner {
  border-color: rgba(96, 165, 250, 0.9);
  box-shadow: 0 0 0 1px rgba(96, 165, 250, 0.7);
}

.modern-input >>> .el-input__inner::placeholder {
  color: rgba(148, 163, 184, 0.8);
}

.modern-input >>> .el-input__inner:focus {
  border-color: #60a5fa;
  box-shadow: 0 0 0 1px rgba(96, 165, 250, 0.8);
}

.modern-input >>> .el-input__prefix,
.modern-input >>> .el-input__suffix {
  color: rgba(148, 163, 184, 0.9);
}

/* 密码切换 */
.password-toggle {
  cursor: pointer;
  font-size: 16px;
}

/* 验证码区域 */
.captcha-input-container {
  display: flex;
  align-items: center;
}

.captcha-img {
  height: 40px;
  width: 108px;
  margin-left: 10px;
  border-radius: 10px;
  border: 1px solid rgba(148, 163, 184, 0.8);
  background-color: rgba(15, 30, 70, 0.9);
}

/* 按钮 */
.login-btn-row {
  margin-top: 6px;
}

.login-submit-button {
  width: 100%;
  font-size: 15px;
  letter-spacing: 0.16em;
  border-radius: 999px;
  background: linear-gradient(135deg, #2563eb, #3b82f6, #22d3ee);
  border: none;
  box-shadow: 0 18px 35px rgba(37, 99, 235, 0.6);
  position: relative;
  overflow: hidden;
  transform: translateZ(0);
}

.login-submit-button:hover {
  filter: brightness(1.05);
  box-shadow:
    0 22px 40px rgba(37, 99, 235, 0.9),
    0 0 25px rgba(56, 189, 248, 0.7);
}

.login-submit-button::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    120deg,
    transparent 0%,
    rgba(248, 250, 252, 0.35) 35%,
    transparent 70%
  );
  transform: translateX(-120%);
  opacity: 0.8;
  mix-blend-mode: screen;
  transition: transform 0.7s ease-out;
}

.login-submit-button:hover::before {
  transform: translateX(120%);
}

/* 底部提示 */
.login-footer-tip {
  margin-top: 10px;
  font-size: 12px;
  color: #9ca3af;
  text-align: center;
}

/* 动画 */
@keyframes aurora-move {
  0% {
    transform: translate3d(-40px, 0, 0) scale(1.02) skewX(-4deg);
    opacity: 0.4;
  }
  50% {
    transform: translate3d(20px, -10px, 0) scale(1.05) skewX(-6deg);
    opacity: 0.75;
  }
  100% {
    transform: translate3d(60px, 10px, 0) scale(1.03) skewX(-3deg);
    opacity: 0.5;
  }
}

@keyframes particle-twinkle {
  0% {
    opacity: 0.3;
    transform: translate3d(0, 0, 0) scale(1);
  }
  50% {
    opacity: 0.6;
    transform: translate3d(14px, -10px, 0) scale(1.05);
  }
  100% {
    opacity: 0.34;
    transform: translate3d(-10px, 6px, 0) scale(1.04);
  }
}

@keyframes card-glow {
  0% {
    opacity: 0;
    transform: translate3d(0, 0, 0);
  }
  40% {
    opacity: 0.6;
    transform: translate3d(40px, 20px, 0);
  }
  60% {
    opacity: 0.3;
    transform: translate3d(80px, 40px, 0);
  }
  100% {
    opacity: 0;
    transform: translate3d(120px, 60px, 0);
  }
}

@keyframes orbit {
  0% {
    transform: rotate(0deg) scale(1);
    opacity: 0.9;
  }
  50% {
    transform: rotate(180deg) scale(1.03);
    opacity: 0.7;
  }
  100% {
    transform: rotate(360deg) scale(1);
    opacity: 0.9;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(18px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card-zoom-enter-active {
  animation: fadeInUp 0.6s ease;
}

/* 呼吸点与标题下划线动画 */
@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.9;
  }
  50% {
    transform: scale(1.25);
    opacity: 0.5;
  }
  100% {
    transform: scale(1);
    opacity: 0.9;
  }
}

.login-hero-title::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -6px;
  width: 90px;
  height: 2px;
  border-radius: 999px;
  background: linear-gradient(90deg, rgba(56, 189, 248, 1), rgba(59, 130, 246, 1), rgba(244, 114, 182, 1));
  overflow: hidden;
}

/* 背景扫描光带动画 */
@keyframes scan-move {
  0% {
    transform: translateX(-60px) skewX(-8deg);
    opacity: 0;
  }
  20% {
    opacity: 0.85;
  }
  50% {
    transform: translateX(80px) skewX(-8deg);
    opacity: 0.55;
  }
  80% {
    opacity: 0;
  }
  100% {
    transform: translateX(140px) skewX(-8deg);
    opacity: 0;
  }
}

/* 标签高光扫过动画 */
@keyframes tag-shine {
  0% {
    transform: translateX(-120%);
    opacity: 0;
  }
  30% {
    opacity: 1;
  }
  100% {
    transform: translateX(120%);
    opacity: 0;
  }
}

/* 响应式 */
@media (max-width: 960px) {
  .login-main {
    padding: 24px 20px 32px;
    flex-direction: column;
    align-items: stretch;
    gap: 24px;
  }

  .login-card-wrapper {
    max-width: 440px;
    margin: 0 auto;
  }

  .login-header {
    padding: 0 20px;
  }
}

@media (max-width: 720px) {
  .login-main {
    min-height: calc(100vh - 56px);
  }
}

@media (max-width: 480px) {
  .login-header {
    height: 56px;
    padding: 0 16px;
  }

  .login-card {
    padding: 22px 18px 20px;
  }

  .login-title {
    font-size: 1.1em;
  }
}
</style>